// extracted by mini-css-extract-plugin
export default {"link":"Link__link___plGt2","focus-visible":"Link__focus-visible___GnVS7","blueLink":"Link__blueLink___BhE5_","underline":"Link__underline___K1Y7j","bold":"Link__bold___JGJNO"};